if (customElements.get('fostr-product-card') === undefined) {
  class FostrProductCard extends HTMLElement {
    get alt () {
      return this.classList.contains('is-alt')
    }

    set alt (value) {
      if (value) {
        return this.classList.add('is-alt')
      }
      return this.classList.remove('is-alt')
    }

    /**
     * Determine whether the given `input` is iterable.
     *
     * @returns {Boolean}
     */
    isIterable (input) {
      if (input === null || input === undefined) {
        return false
      }

      return typeof input[Symbol.iterator] === 'function'
    }

    constructor () {
      super()

      this.productGrid = this.closest('fostr-product-grid')
      this.videoBtn = this.querySelector('[data-video]')
      this.mediaContainer = this.querySelector('.media')
      this.videoRendered = false
      this.listOptions = Array.from(
        this.querySelectorAll('.product-options__list input[type="radio"]'),
      )
      this.listButton = this.querySelector('.product-options__list .button')

      this.addEventListener('click', event => this.onClick(event))

      this.sortSizes()
      this.initListControls()
    }

    initListControls () {
      this.listOptions.forEach(listOption => {
        if (!listOption) return
        if (listOption.checked) {
          listOption.setAttribute('checked', false)
        }
        listOption.addEventListener('click', this.onClickListOption.bind(this))
      })

      if (!this.listButton) return
      if (this.listButton.checked) {
        this.listButton.setAttribute('checked', false)
      }
      this.listButton.addEventListener(
        'click',
        this.onClickListButton.bind(this),
      )
    }

    onClickListOption (event) {
      const selectedOption = this.listOptions.find(x => x.checked)
      const currentButtonText = this.listButton.querySelector('span')
        .textContent
      const errorContainer = this.querySelector('.product-options__list__error')

      if (errorContainer) errorContainer.textContent = ''

      if (selectedOption.checked) {
        // Update List Button
        if (this.listButton) {
          if (this.listButton.hasAttribute('data-selected')) {
            this.listButton.querySelector(
              'span',
            ).textContent = this.listButton.dataset.selected
          }
          this.listButton.removeAttribute('disabled')
        }
      } else {
        // Update List Button
        if (this.listButton) {
          this.listButton.querySelector('span').textContent = currentButtonText
          this.listButton.setAttribute('disabled', true)
        }
      }
    }

    onClickListButton (event) {
      const selectedOption = this.listOptions.find(x => x.checked)
      const currentButtonText = this.listButton.querySelector('span')
        .textContent
      const variantId = selectedOption
        ? this.getVariantId(selectedOption.value)
        : event.currentTarget.dataset.id
      const cartItems = document.querySelector('cart-items')
      const errorContainer = this.querySelector('.product-options__list__error')

      if (errorContainer) errorContainer.textContent = ''

      this.listButton.querySelector(
        'span',
      ).textContent = this.listButton.dataset.loading
      this.listButton.setAttribute('disabled', true)

      const body = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }

      if (cartItems) {
        body.sections = cartItems
          .getSectionsToRender()
          .map(section => section.id)
        body.sections_url = window.location.pathname
      }

      fetch(`${window.routes.cart_add_url}`, {
        ...window.fetchConfig('javascript'),
        body: JSON.stringify(body),
      })
        .then(response => response.json())
        .then(response => {
          //  Error
          if (response.status) {
            if (errorContainer) { errorContainer.textContent = response.description }
            this.listButton.querySelector(
              'span',
            ).textContent = currentButtonText
            return
          }

          // Success
          if (cartItems) {
            cartItems.renderContents(response)
          }

          this.listButton.querySelector(
            'span',
          ).textContent = this.listButton.dataset.success

          return new Promise(resolve =>
            setTimeout(() => {
              if (this.listButton.hasAttribute('data-selected')) {
                this.listButton.querySelector(
                  'span',
                ).textContent = this.listButton.dataset.selected
              } else {
                this.listButton.querySelector(
                  'span',
                ).textContent = this.listButton.dataset.default
              }

              resolve()
            }, 1000),
          )
        })
        .catch(e => {
          console.error(e)
        })
        .finally(() => {
          this.listButton.removeAttribute('disabled')
        })
    }

    getVariantId (optionValue) {
      try {
        if (!optionValue) throw 'The "optionValue" is required.'

        const variantData = JSON.parse(
          this.querySelector('[type="application/json"]').textContent,
        )
        if (!variantData) throw 'Failed to parse variant data.'

        const selectedVariant = variantData.find(variant => {
          return variant.option1 === optionValue
        })
        if (!selectedVariant) throw 'A matching variant was not found.'
        if (!selectedVariant.id) { throw 'The matching variant did not have an ID.' }

        return selectedVariant.id
      } catch (ex) {
        return null
      }
    }

    sortSizes () {
      if (typeof sortSizes !== 'undefined') {
        window.sortSizes(
          this.querySelector(
            '.product-connections fieldset.product-form__input ul.product-form__input__group',
          ),
        )
        window.sortSizes(
          this.querySelector(
            '.product-options__list fieldset.product-form__input ul.product-form__input__group',
          ),
        )
      }
    }

    async update () {
      await customElements.whenDefined(this.productGrid.localName)

      this.alt = this.productGrid.view === true
    }

    onClick (event) {
      this.clickedOnQuickBuy = false
      this.clickedOnOrbLoader = false

      if (!this.isIterable(event.path)) {
        return
      }

      for (const pathElement of event.path) {
        if (pathElement.classList) {
          if (pathElement.classList.contains('quick-buy__wrapper')) {
            this.clickedOnQuickBuy = true
            break
          }
          if (pathElement.classList.contains('card__utils')) {
            this.clickedOnOrbLoader = true
            break
          }
        }
      }

      if (this.clickedOnOrbLoader) {
        this.toggleOrb360()
      } else if (!this.clickedOnQuickBuy) {
        // this.goToProduct();
      }
    }

    generateORB360 () {
      const orbID = this.getAttribute('orb-id')
      if (orbID) {
        const iframe = document.createElement('iframe')
        iframe.frameBorder = '0'
        iframe.allowFullscreen = true
        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        iframe.setAttribute(
          'src',
          `https://cdn.orb360.tech/orb360embed/v1.1.0/?tenant=2440f06a-eddd-421d-8003-da14a46bf69e&endpoint=id&q=${orbID}&duration=5000&zoom=false&allowFullscreen=false&playMode=once`,
        )
        return iframe
      } else {
        return ''
      }
    }

    toggleOrb360 () {
      if (!this.videoRendered) {
        this.videoBtn.classList.add('is-active')
        const orb360 = this.generateORB360()
        this.querySelector('.fostr-product-card-media-container').appendChild(
          orb360,
        )
        this.videoRendered = true
        this.hideImages()
      } else {
        this.videoBtn.classList.remove('is-active')
        this.showImages()
        this.querySelector('iframe').remove()
        this.videoRendered = false
      }
    }

    goToProduct () {
      const url = this.getAttribute('product-url')
      window.location.href = url
    }

    hideImages () {
      this.setAttribute('images-hidden', '')
    }

    showImages () {
      this.removeAttribute('images-hidden')
    }
  }

  customElements.define('fostr-product-card', FostrProductCard)
}
